var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnLargeScore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.491 13.409H12.51c-3.374 0-6.11 2.865-6.11 6.4v48c0 3.534 2.736 6.4 6.11 6.4H67.49c3.374 0 6.11-2.866 6.11-6.4v-48c0-3.535-2.736-6.4-6.11-6.4z",
    stroke: "#003A70",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.727 7.009v12.8M55.273 7.009v12.8",
    stroke: "#003A70",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.583 44.148c2.162 0 6.92.533 6.92 5.866 0 3.734-2.595 5.843-6.055 5.867-1.668-.041-3.302-.591-4.757-1.6M47.124 35.081c1.28-1.05 2.786-1.607 4.324-1.6 2.604 0 5.19 1.6 5.19 4.8 0 4.267-3.46 5.867-5.19 5.867h-.864M42.37 42.815h-3.2M20.905 47.14c.697-2.842 3.58-4.918 6.201-4.918 1.498-.035 2.946.664 4.026 1.944 1.08 1.281 1.703 3.038 1.733 4.885-.03 1.847-.654 3.604-1.733 4.885-1.08 1.28-2.528 1.98-4.026 1.944-3.18 0-6.644-3.278-6.644-9.287 0-8.195 4.43-13.112 10.63-13.112",
    stroke: "#003A70",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnLargeScore);
export default __webpack_public_path__ + "static/media/icn_large_score.wtn-site.svg";
export { ForwardRef as ReactComponent };